import { gql } from "@apollo/client";

export const customModelValuesQuery = gql`
  query customModelValues($scenarioId: ID!, $filter: CustomModelValueFilterInput) {
    data(scenarioId: $scenarioId) {
      customModelValues(filter: $filter) {
        items {
          id
          code
          value
          label
          customModel {
            id
            code
            name
          }
          usable
          enabled
          meta
        }
        pageInfo {
          page
          size
          total
          hasNextPage
          __typename
        }
      }
    }
  }
`;
